import { useEffect, useState } from "react";
import { NumberInput } from "../../../components/numberInput/numberInput";
import { useSelector } from "react-redux";
import { Header } from "../../../components/header/header";
// import TableAPI from "../../../api/TableAPI";
import MotivationAPI from "../../../api/MotivationAPI";

import { Text } from "../../../components/text/text";

import styles from "./motivationPage.module.css"

const MotivationSetting = ({ val, setVal, label, ...params }) => {
    return (
        <div className={styles.motivation_setting}>
            <Text as="div" variant="caption" className={styles.motivation_setting_label} >{label}</Text>
            <NumberInput val={val} setVal={setVal} {...params} />
        </div>
    )
}

const initialSettings = {
    salaryPerHour: 0,
    hoursPerShift: 0,
    countShiftsMonthly: 0,
    baseSalary: 0,
    bonusPercentage: 0,
    avgRevenue: 0,
};

export const MotivationPage = () => {
    const [settings, setSettings] = useState(initialSettings);

    const userId = useSelector(state => state.user.userId);

    useEffect(() => {
        if (!userId)
            return;

        MotivationAPI
            .fetchMotivation(userId)
            .then(res => setSettings(res))
            .catch(() => setSettings(initialSettings));
    }, [userId]);

    // const [hours, setHours] = useState(0);
    // const [days, setDays] = useState(0);

    // useEffect(() => {
    //     if (!userId)
    //         return;

    //     TableAPI
    //         .fetchTotalShifts()
    //         .then(({ shifts, hours }) => {
    //             setHours(hours);
    //             setDays(shifts);
    //         })
    //         .catch(console.error);
    // }, [userId]);

    return (
        <>
            <Header title="Моя мотивация" />
            <div className={styles.motivation_settings}>
                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", rowGap: "14px", columnGap: "10px" }}>
                    <MotivationSetting disabled label="Кол-во смен в месяце" val={settings.countShiftsMonthly} />
                    <MotivationSetting disabled label="Кол-во часов в смене" val={settings.hoursPerShift} />
                    <MotivationSetting disabled label="Часовая ставка руб./час" val={settings.salaryPerHour} />
                    <MotivationSetting disabled label="Оклад в месяц (если есть)" val={settings.baseSalary} />
                    <MotivationSetting disabled label="Процент бонуса" val={settings.bonusPercentage} />
                    <MotivationSetting disabled label="План по сред. чеку" val={settings.avgRevenue} />
                </div>
            </div>
        </>
    )
}
